import {createContext} from 'react';

export const Context = createContext();
export const ContextUser = createContext();
export const ContextGame = createContext();

